// There is no runtime env flag; staging is the API host the build points at.
export const isStaging = (process.env.REACT_APP_API_URL || "").includes("staging");
